const texts = {
    heroTextsList: {
        "en" :{
            sequence: [
                "NajjarGames. is where I\ndesign for fun.",
                1000,
                "NajjarGames. is where I\nbring to life many ideas.",
                1000,
                "NajjarGames. is where I\nshare with you all.",
                1000,
                "NajjarGames. is where I\ndevelop for joy.",
                1000,
                "NajjarGames. is where I\ntest endlessly.",
                1000,
                "NajjarGames. is where I\nrefine constantly.",
                1000,
                "NajjarGames. is where I\ninnovate tirelessly.",
                1000,
                "NajjarGames. is where I\nmake games with players in mind.",
                1000,
                "NajjarGames. is where I\ndesign from scratch.",
                1000,
                "NajjarGames. is where I\ntest until they shine.",
                1000,
                "NajjarGames. is where I\nwish existed when I was a kid.",
                1000,
                "NajjarGames. is where I\npour my soul into.",
                1000,
                "NajjarGames. is where I\nbring to your table an experience.",
                1000,
                "NajjarGames. is where I\nstart with a crazy sketch.",
                1000,
                "NajjarGames. is where I\ngrow from tiny ideas.",
                1000,
                "NajjarGames. is where I\nbuild to tell stories.",
                1000,
                "NajjarGames. is where I\nrefine one rule at a time.",
                1000,
                "NajjarGames. is where I\ncreate from chaos.",
                1000,
                "NajjarGames. is where I\nbring people together.",
                1000,
                "NajjarGames. is where I\nchallenge myself.",
                1000,
                "NajjarGames. is where I\nplay with passion.",
                1000,
                "NajjarGames. is where I\nimagine daily.",
                1000,
                "NajjarGames. is where I\nbuild games with love.",
                1000,
            ]
        },
        "pt-BR": {
            "sequence": [
                "NajjarGames. é onde eu\nfaço jogos por diversão.",
                1000,
                "NajjarGames. é onde eu\ndou vida a muitas ideias.",
                1000,
                "NajjarGames. é onde eu\ncompartilho com vocês.",
                1000,
                "NajjarGames. é onde eu\ndesenvolvo com alegria.",
                1000,
                "NajjarGames. é onde eu\ntesto sem parar.",
                1000,
                "NajjarGames. é onde eu\nrefino constantemente.",
                1000,
                "NajjarGames. é onde eu\ninovo incansavelmente.",
                1000,
                "NajjarGames. é onde eu\ncrio jogos pensando nos jogadores.",
                1000,
                "NajjarGames. é onde eu\ndesenho do zero.",
                1000,
                "NajjarGames. é onde eu\ntesto até brilhar.",
                1000,
                // "NajjarGames. é onde eu\nqueria que existisse quando criança.",
                // 1000,
                "NajjarGames. é onde eu\ndeposito minha alma.",
                1000,
                "NajjarGames. é onde eu\ntrago uma experiência para sua mesa.",
                1000,
                "NajjarGames. é onde eu\ncomeço com um rascunho maluco.",
                1000,
                "NajjarGames. é onde eu\ncresço a partir de ideias pequenas.",
                1000,
                "NajjarGames. é onde eu\ncrio para contar histórias.",
                1000,
                "NajjarGames. é onde eu\nrefino uma regra de cada vez.",
                1000,
                "NajjarGames. é onde eu\ncrio a partir do caos.",
                1000,
                "NajjarGames. é onde eu\naproximo as pessoas.",
                1000,
                "NajjarGames. é onde eu\ndesafio a mim mesmo.",
                1000,
                "NajjarGames. é onde eu\njogo com paixão.",
                1000,
                // "NajjarGames. é onde eu\nme imagino todos os dias.",
                // 1000,
                "NajjarGames. é onde eu\ncrio jogos com amor.",
                1000
            ]
        }
    },
    changeLanguage: {
        "pt-BR": "Change to English",
        "en": "Mudar para Português"
    },
    aboutMe1: {
        "pt-BR": "Sou Rafael Najjar e venho criando e desenvolvendo jogos de tabuleiro desde 2014. Em 2025, decidi compartilhar minhas criações com o mundo, e agora meu objetivo é atrair uma editora que se interesse em publicar meus jogos.",
        "en": "I'm Rafael Najjar, and I've been designing and developing board games since 2014. In 2025, I decided to share my creations with the world, and my goal now is to attract a publisher to take interest in my games."
    },
    aboutMe2: {
        "pt-BR": "Eu tento ser um criador sempre que posso. Gosto de novos desafios, não importa o assunto, e adoro resolver problemas por meio da criatividade. É por isso que, como desenvolvedor, estou sempre experimentando novas mecânicas em cada projeto.",
        "en": "I try to be a creator whenever I can. I enjoy new challenges, no matter the subject, and I love solving problems through creativity. That’s why, as a developer, I’m always experimenting with new mechanics in each project."
    },
    aboutMe3: {
        "pt-BR": (<>
            Espero que você goste da <span style={{ fontFamily: "Righteous" }}>NajjarGames.</span> tanto quanto eu, porque estou colocando muito da minha vida nesse projeto — finalmente podendo compartilhar tudo o que crio com você. Aqui, você pode explorar meus projetos pessoais e os produtos que imagino para o futuro.
        </>),
        "en": (<>
            I hope you like <span style={{ fontFamily: "Righteous" }}>NajjarGames.</span> as much as I do, because I’m pouring a lot of my life into it — finally able to share everything I create with you. Here, you can explore my personal projects and the products I envision for the future.
        </>)
    },
    aboutMe4: {
        "pt-BR": "Fiquem a vontade de entrar em contato comigo sobre o que for!",
        "en": "Feel free to reach out to me anytime, any day, about anything!"
    },
    aboutNajjarGames: {
        "pt-BR": "Sobre NajjarGames.",
        "en": "About NajjarGames."
    },
    jlfDescription:{
        "pt-BR": (<span>Jogos Legais Findessemanais. É o meu evento que faço onde levo minha coleção de jogos — e aproveito para fazer playtests! Acontece mensalmente no Rio de Janeiro.</span>),
        "en": (<span>My event with friends to play my collection of board games — and also playtest my own designs! It happens monthly in Rio de Janeiro.</span>)
    },
    futureProjectsDesktop: {
        "pt-BR": "Jogos que estou desenvolvendo",
        "en": "Games that I'm developing"
    },
    futureProjectsMobile: {
        "pt-BR": "Em desenvolvimento",
        "en": "In development"
    },
    otherThingsDesktop: {
        "pt-BR": "Outras Coisas",
        "en": "Other Things"
    },
    otherThingsMobile: {
        "pt-BR": "Outras Coisas",
        "en": "Other Things"
    },
    mainGamesDesktop: {
        "pt-BR": "Procurando editoras",
        "en": "Looking for Publishers"
    },
    mainGamesMobile: {
        "pt-BR": "Procurando editoras",
        "en": "Looking for Publishers"
    },
    "3014": {
        "pt-BR": "3014: Projeto Último Suspiro",
        "en": "3014: Project Last Whisper"
    },
    cariocar: {
        "pt-BR": "Cariocar",
        "en": "Rio de Janeiroing"
    },
    ovos: {
        "pt-BR": "Ovos.",
        "en": "Eggs."
    },
    regentes: {
        "pt-BR": "Regentes",
        "en": "Regents"
    },
    gaed: {
        "pt-BR": "Batalhas por Ga'ed",
        "en": "Ga'ed: Duel"
    },
    playNow: {
        "pt-BR": "Jogue Agora!",
        "en": "Play Now!"
    },
    videos: {
        "pt-BR": "Vídeos",
        "en": "Videos"
    },
    files: {
        "pt-BR": "Arquivos",
        "en": "Files"
    },
}

export default texts